import React, { useState, useEffect, useMemo } from "react";
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import WebResourceImage from "components/WebResourceImage";
import ErrorMessageView from "components/ErrorMessageView";
import { TouchRole } from "localResouces";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Template } from 'devextreme-react/core/template';

//Redux
import { connect } from "react-redux";

// Component styles
import classes from "./MaintasksToolbar.module.scss";

function MaintasksToolbar(props) {
  const { showMainTasks, currentDataSegment, currentDataSegmentSessionId, navigateTo, currentUILanguageCode } = props;

  const [maintasks, setMaintasks] = useState([]);
  const [compactMode, setCompactMode] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        console.log("GetMainTasks for session " + currentDataSegmentSessionId)
        let result = await BosWebGuiServices.fetchGetMainTasks(currentDataSegment.authToken, currentDataSegmentSessionId, currentDataSegment.id);
        console.log("Maintasks for DataSegmentId " + currentDataSegment.id + " result:", result);
        setMaintasks(result);
        setError(false);
      } catch (error) {
        console.error("Maintasks for DataSegmentId " + currentDataSegment.id + " error:", error);
        setMaintasks([]);
        setError(true);
      }
    }

    if (currentDataSegment && currentDataSegmentSessionId) fetchData();
    else setMaintasks([]);

  }, [currentDataSegment, currentDataSegmentSessionId, currentUILanguageCode]);

  const toggleViewButtonOptionsMemo = useMemo(() => {
    return {
      icon: compactMode ? "expand" : "collapse",
      stylingMode: "text",
      onClick: () => setCompactMode(prev => !prev)
    };
  }, [compactMode]);

  const renderButton = (task) => {
    return (
      <Button
        className={classes.maintaskbuttoncontainer}
        key={task.taskId}
        stylingMode={'text'}
        onClick={() => navigateTo(task.targetUri)}
        template={'btn'}
      >
        <Template name='btn'>
          <div className={classes.maintaskbuttontemplate}>
            <WebResourceImage className={classes.maintaskbuttonicon} size={compactMode ? 28 : 32} fallBackImage={TouchRole} fileId={task.iconExternalDocId} />
            {!compactMode
              ? (
                <div className={classes.maintaskbuttontext}>
                  {task.name}
                </div>
              )
              : null
            }
          </div>
        </Template>
      </Button>
    );
  };

  const renderButtonInMenu = (task) => {
    return (
      <Button
        className={classes.maintaskbuttoncontainerInMenu}
        key={task.taskId}
        stylingMode={'text'}
        onClick={() => navigateTo(task.targetUri)}
        template={'btn'}
      >
        <Template name='btn'>
          <div className={classes.maintaskbuttontemplateInMenu}>
            <WebResourceImage className={classes.maintaskbuttonicon} size={24} fallBackImage={TouchRole} fileId={task.iconExternalDocId} />
            <div className={classes.maintaskbuttontextInMenu}>{task.name}</div>
          </div>
        </Template>
      </Button>
    );
  };

  const renderErrorToolbarItem = () => {
    return (
      <Item
        key={"error"}
        location="before"
        render={() => <ErrorMessageView/>}
      >
      </Item>
    );
  };

  const renderToolbarItem = (task) => {
    return (
      <Item
        key={task.taskId}
        location="before"
        locateInMenu="auto"
        render={() => renderButton(task)}
        menuItemRender={() => renderButtonInMenu(task)}
      >
      </Item>
    );
  };

  const renderToggleViewButton = () => {
    return (
      <Item
        location="after"
        locateInMenu="never"
        widget="dxButton"
        options={toggleViewButtonOptionsMemo}
      >
      </Item>
    );
  };

  return (
    <Toolbar 
    className={cn(classes.mainTasksToolbar, "dx-theme-border-color", showMainTasks ? classes.visible : classes.hidden)} 
    style={{height: showMainTasks ? (compactMode ? "42px" : "70px") : 0}}
    >
      {error
        ? renderErrorToolbarItem()
        : (
          maintasks.map(task => (
            renderToolbarItem(task)
          ))
        )
      }
      {renderToggleViewButton()}
    </Toolbar>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
  };
}

export default connect(mapStateToProps)(MaintasksToolbar);
